import { render, staticRenderFns } from "./ReviewUs.vue?vue&type=template&id=9582264c&scoped=true&"
import script from "./ReviewUs.vue?vue&type=script&lang=js&"
export * from "./ReviewUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9582264c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9582264c')) {
      api.createRecord('9582264c', component.options)
    } else {
      api.reload('9582264c', component.options)
    }
    module.hot.accept("./ReviewUs.vue?vue&type=template&id=9582264c&scoped=true&", function () {
      api.rerender('9582264c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ReviewUs.vue"
export default component.exports